"use client";
import AppImage from "../common/AppImage";

// Cut-out artwork usually has transparent space above the subject, and how
// much varies per image. Measure it once loaded and expose it as --art-top
// (a fraction of the image height) so the CSS can tuck that empty band under
// the card copy while the visible artwork stays clear of it.
function measureTransparentTop(img) {
  const { naturalWidth: nw, naturalHeight: nh } = img;
  if (!nw || !nh) return 0;

  // Enough resolution that thin or faint edges (e.g. a film strip outline)
  // aren't averaged away by the downscale.
  const w = Math.min(nw, 160);
  const h = Math.max(1, Math.round((w * nh) / nw));
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d", { willReadFrequently: true });
  ctx.drawImage(img, 0, 0, w, h);
  const data = ctx.getImageData(0, 0, w, h).data;

  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      if (data[(y * w + x) * 4 + 3] > 8) return y / h;
    }
  }
  return 0;
}

export default function ServiceCardImage(props) {
  return (
    <AppImage
      {...props}
      onLoad={(e) => {
        const img = e.currentTarget;
        try {
          // Capped so a mostly-empty image can't blow up the artwork.
          const top = Math.min(measureTransparentTop(img), 0.4);
          img.style.setProperty("--art-top", top.toFixed(3));
        } catch {
          // Unreadable (e.g. cross-origin) — keep the no-overlap default.
        }
      }}
    />
  );
}
